import { Link } from 'react-router-dom';
// Shared button-link styling (.phi-btn-primary) lives with the Payroll History Import feature this card links to.
import '../../payroll-history-import/payroll-history-import.css';
import { INTEGRATION_STATUS } from '../types';

/** A read-only status aggregator — same architectural shape as the Audit History screen: the backend
 * stays fully distributed (see docs/integrations-architecture.md), only the UI presents one merged view.
 * No gateway, no API call — every interface below is a Mock service selected at DI-registration time, not
 * a live connection with a status to poll. See docs/integrations.md. */
export function IntegrationsPage() {
  return (
    <section className="card card--wide">
      <div className="section-header">
        <h2>Integrations</h2>
        <span className="badge badge--caution">No live connection to any external provider exists</span>
      </div>
      <p className="muted">
        A read-only status view over EPN's distributed provider adapters — see{' '}
        <code>docs/integrations-architecture.md</code> for why this stays distributed rather than a
        centralized service, and <code>docs/integrations.md</code> for this screen's own scope. This never
        represents a simulated integration as "Connected."
      </p>

      <section aria-labelledby="payroll-data-imports-heading">
        <h3 id="payroll-data-imports-heading">Payroll data imports</h3>
        <p className="muted">
          Bring historical payroll records from a previous payroll system into Escochex Payroll Next as read-only history.
        </p>
        <Link to="/payroll/import-payroll-data" className="phi-btn-primary">
          Import Payroll History
        </Link>
      </section>

      <table>
        <thead>
          <tr><th>Provider</th><th>Purpose</th><th>Status</th><th>Environment</th><th>Owning Module</th><th>Capabilities</th></tr>
        </thead>
        <tbody>
          {INTEGRATION_STATUS.map((row) => (
            <tr key={row.provider}>
              <td>{row.provider}</td>
              <td className="muted">{row.purpose}</td>
              <td>
                <span className={row.status === 'Not Configured' ? 'badge badge--blocked' : 'badge badge--caution'}>
                  {row.status}
                </span>
              </td>
              <td>{row.environment}</td>
              <td className="muted">{row.owningModule ?? '—'}</td>
              <td className="muted">{row.capabilities.length > 0 ? row.capabilities.join('; ') : '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
